import pako from 'pako';

const METHODS_WITH_BODY = new Set(['POST', 'PUT', 'PATCH', 'DELETE']);

const normalizeHeaders = (headers = {}) => new Headers(headers);

const shouldCompressRequest = (method, body, headers, gzipEnabled) => {
  if (gzipEnabled === false) {
    return false;
  }

  if (!METHODS_WITH_BODY.has((method || 'GET').toUpperCase())) {
    return false;
  }

  if (body == null || body instanceof FormData || body instanceof Blob) {
    return false;
  }

  if (headers.get('Content-Encoding')) {
    return false;
  }

  const contentType = headers.get('Content-Type') || '';
  return contentType.toLowerCase().includes('application/json');
};

const buildRequestOptions = (options = {}) => {
  const requestOptions = { ...options };
  const headers = normalizeHeaders(options.headers);
  const method = requestOptions.method || 'GET';
  const gzipEnabled = requestOptions.gzip;

  delete requestOptions.gzip;

  if (shouldCompressRequest(method, requestOptions.body, headers, gzipEnabled)) {
    const payload = typeof requestOptions.body === 'string'
      ? requestOptions.body
      : JSON.stringify(requestOptions.body);

    requestOptions.body = pako.gzip(payload).buffer;
    headers.set('Content-Encoding', 'gzip');
  }

  requestOptions.headers = headers;
  return requestOptions;
};

export const apiFetch = async (endpoint, options = {}) => {
  let response;
  let data;

  const reload = () => {
    window.location.href = "./acceso";
  }

  try {
    response = await fetch(endpoint, buildRequestOptions(options));
    const clonedResponse = response.clone();
    try {
      data = await clonedResponse.json();
    } catch (parseError) {
      alert("Error al parsear la respuesta de la API como JSON:", parseError);
      if (!response.ok) { 
        reload(); 
      }
      return response;
    }
    
    if (response.ok && data.estatus === "error" && (data.mensaje === "No hay sesión iniciada" || data.mensaje === "Sesión inválida")) {
        alert("Se venció la sesión, regresando al login...");
        reload();
    }

    if (!response.ok) {
        alert("Hay un problema con el servidor, intentalo de nuevo mas tarde.")
        reload(); 
    }
    return response;

  } catch (err) {
    alert("Error en la petición de red:", err);
    throw err;
  }
};